<div style="padding: 30px;">
  <!-- Header -->
  <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid var(--green-800);margin-bottom: 10px;">
    <h2 style="font-family: ABC Arizona Flare; font-size: 30px; font-weight: 400; color: var(--green-700);">View & Manage Invoices</h2>
    <div style="display: flex; gap: 20px; align-items: center; margin-bottom: 30px;">
      <span style="color: var(--green-800); cursor: pointer; text-decoration: underline; text-underline-offset: 4px; font-size: 14px; margin-top: 10px;" (click)="onInvoiceSettingsClicked()">Invoice Settings</span>
      <button class="btn-core" (click)="onCreateInvoiceClicked()">Create Invoice</button>
    </div>
  </div>

  <!-- Content -->
   <div style="margin-top: 10px;">
     <app-filterable-table
      #invoiceTable
      [titles]="['Sent','Paid','Draft']"
      [searchBarSize]="'75%'"
      [multipleTableViews]="[sentInvoicesTableView, paidInvoicesTableView, draftInvoicesTableView]"
      [multipleTableOptions]="[sentInvoicesTableOptions, paidInvoicesTableOptions, draftInvoicesTableOptions]"
    ></app-filterable-table>`
   </div>
</div>
